import React, { useEffect, useState } from "react";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import BackButton from "../components/BackButton";
import DyslexiaScreenerResultsOverview from "../components/DyslexiaScreenerResultsOverview";
import { useLocation } from "react-router-dom";
import { whoami } from "../services/APIClient";
import { Container, Row, Col } from "react-bootstrap";
import OrientationPrompt from "../components/OrientationPrompt";

function DyslexiaScreenerResults() {
  const location = useLocation();
  const [schoolid, setSchoolid] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("");

  const studentName = location.state?.student?.name || "";

  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    whoami().then((response) => {
      setSchoolid(response.data.stakeholder.schoolid);
      setTeacherid(response.data.stakeholder.id);
      setName(response.data.stakeholder.name);
    });
  }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  return (
    <div>
      <Container fluid className="vh-100">
        <HeadingBanner
          name={`Dyslexia Screener Results — ${studentName}`}
          isLoggedIn={true}
          cloud={true}
          teacherid={teacherid}
        />

        <Row className="h-100">
          <LeftPanel />
          <Col sm={{ span: 10, offset: 2 }} className="blue-background">
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '15px', marginLeft: '10px' }}>
              <BackButton />
            </div>
            <DyslexiaScreenerResultsOverview />
          </Col>
        </Row>
      </Container>
      {isPortrait && <OrientationPrompt />}
    </div>
  );
}

export default DyslexiaScreenerResults;
